import { Typography } from '../Typography';

interface TestimonialsCloudItemProps {
  data: Testimonial;
}

export const TestimonialsCloudItem: React.FC<TestimonialsCloudItemProps> = ({
  data,
}) => (
  <div className="flex flex-shrink-0 flex-grow-0 basis-full flex-col items-center gap-6 px-8 text-center md:px-0">
    <Typography
      variant="body1"
      className="max-w-[37rem] text-lg font-bold text-neutral-900"
    >
      {data?.title}
    </Typography>
    <Typography
      variant="body1"
      className="max-w-[37rem] italic leading-6 text-neutral-900"
    >
      {data?.content}
    </Typography>

    <div className="flex flex-col gap-1">
      <Typography className="text-sm font-bold leading-tight text-neutral-900">
        {data?.author_name}
      </Typography>
      <Typography className="text-sm leading-tight text-neutral-500">
        {data?.author_title}
      </Typography>
    </div>
  </div>
);
